import { useAppState } from "../context-hooks/useAppState";
import { usePlan } from "./usePlan";

/** simple helper for accessing the plan selected for enrollment */
export const useEnrollPlan = () => {
  const { enrollPlanId } = useAppState();
  return usePlan({ planId: enrollPlanId });
};
